
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw } from '../../lib'
// import AsideBar from './AsideBar'

import './chat-resume.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function CallChatResume(props) {
    const { data } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(false)
    const [assement, setAssement] = useState(data) 

    useEffect(() => {
        setAssement(data)
    }, [data])
  
    return (

        <>
            <div class="info-call-item header flex items-center w-full justify-center" style={{ padding: 15, backgroundColor: "white" }} >
                <div class="agents flex items-center ">
                    <div class="img">

                        <img alt='' src="/icons/tpAgent.png" style={{ width: 150, objectFit: 'contain', marginRight: 30 }} />

                    </div>
                    <div class="img">
                        <img src="/icons/tpClient.png" alt="" style={{ width: 180, objectFit: 'contain' }} />
                        {/* <!--<span>TP Client</span>--> */}
                    </div>
                </div>
                <div class="higiliths">
                    <img alt="" src="/icons/sentiment2.png" style={{ width: 142, height: 143, objectFit: 'contain' }} />
                </div>
            </div>
            <div class="call-resume-container" >
                <div class="call-resume-loading">
                    <h2>Conversation</h2>
                </div>
                <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                    <div id="sidebar-chat" class="call-resume-indicators" >
                        {assement?.sentiment.map((item, idex) => (
                            <div class=""  >
                                {item.user !== '' &&
                                    <div class="call-resume-text" style={{paddingTop:15, paddingBottom:15}}>
                                        <div className='flex items-start justify-start'>
                                            <img class="avatar_left" src="/icons/tpAgentMini.png" alt="" style={{ marginLeft: 12 }} />
                                            <div className='flex flex-col items-start justify-start'>
                                                <div class="text-left">Polarity: {item.polarity}</div>
                                                <div class="text-left" style={{ color: '#575756',width:500 }}>{item.user}</div>
                                            </div>

                                        </div>

                                    </div>
                                }
                                <div style={{ display: 'flex', justifyContent: 'flex-end'}} >
                                    <p class="text-bot chat-bot" style={{ color: '#575756',width:500 }}>{item?.bot}
                                        <img class="avatar_right" src="/icons/tpClientMini.png" alt="" />
                                    </p>
                                </div>
                            </div>))}
                    </div>
                </div>
            </div>

        </>


    )
}
